import { ActionIcon, Anchor, Group, Text } from '@mantine/core';
import { GBFlag, SEFlag } from 'mantine-flagpack';
import { t } from 'ttag';
import { getLocale, setLocale } from '../i18nInit';

interface LocaleSwitcherProps {
  withText?: boolean;
}

export const LocaleSwitcher = ({ withText }: LocaleSwitcherProps) => {
  const toggleLocale = () => {
    if (getLocale() === 'sv') {
      setLocale('en');
    } else {
      setLocale('sv');
    }

    window.location.reload();
  };

  if (withText) {
    return (
      <Anchor onClick={() => toggleLocale()} c="dimmed">
        <Group gap={'xs'}>
          {getLocale() === 'en' && (
            <>
              <GBFlag style={{ width: 16 }} radius={'xs'} title={t`Engelska`} />
              <Text c="dimmed" size="sm">
                English
              </Text>
            </>
          )}
          {getLocale() === 'sv' && (
            <>
              <SEFlag style={{ width: 16 }} radius={'xs'} title={t`Svenska`} />
              <Text c="dimmed" size="sm">
                Svenska
              </Text>
            </>
          )}
        </Group>
      </Anchor>
    );
  }

  if (getLocale() === 'sv') {
    return (
      <ActionIcon onClick={() => toggleLocale()} variant="subtle" mt={2}>
        <SEFlag style={{ width: '18px' }} radius={'xs'} title={t`Svenska`} />
      </ActionIcon>
    );
  }

  return (
    <ActionIcon onClick={() => toggleLocale()} variant="subtle" mt={2}>
      <GBFlag style={{ width: '18px' }} radius={'xs'} title={t`Engelska`} />
    </ActionIcon>
  );
};
